import { render } from "./GuideSummary.vue?vue&type=template&id=e53b9d4a&scoped=true"
import script from "./GuideSummary.vue?vue&type=script&lang=js"
export * from "./GuideSummary.vue?vue&type=script&lang=js"

import "./GuideSummary.vue?vue&type=style&index=0&id=e53b9d4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_e6684e1c54ce0e601933c41c13e63276/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e53b9d4a"]])

export default __exports__